import { render, staticRenderFns } from "./ModerateIcon.vue?vue&type=template&id=5acd8f8d"
import script from "./ModerateIcon.vue?vue&type=script&lang=js"
export * from "./ModerateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports